const featurePricingModule = [
    {
        selector: '[data-feature-pricing-module]',
        path: { filename: 'featurePricingModule' },
    },
];

export { featurePricingModule };
